import React, { useContext } from 'react'
import '../ProjectMilestones/styles.scss'
import ProjectAvatar from '../shared/ProjectAvatar'
import CountProjects from '../shared/CountProjects'
import HeaderExtended from '../HeaderExtended'
import usePortfolioName from '../../../../../hooks/usePortfolioName'
import { TagFilterContext } from '../../../../../context/TagFilterContext'
import { useTranslation } from 'react-i18next'
import { ProjectMilestonesData } from '../GeneralInformation/typesExtendedReport'
import { useProjectMilestonesMappedData } from './useProjectMilestonesMappedData'
import MilestoneCard from './components/MilestoneCard'
import ReusableIcon from '../shared/ReusableIcon'

type MilestonesProps = {
    data: ProjectMilestonesData | null | undefined;
    isLoan?: boolean;
    isTcp?: boolean;
    isIgr?: boolean;
    creationDate?: Date;
    regions?: any;
    countries?: string;
    myPortfolio?: string;
    filtersApplied?: any;
}
const ProjectMilestones: React.FC<MilestonesProps> = ({ data, isLoan, isTcp, isIgr, creationDate, regions, countries, myPortfolio, filtersApplied }) => {
    const { t } = useTranslation();
    const portfolioName = usePortfolioName();
    const { labels } = useContext(TagFilterContext);
    const titleLon = 'LON';
    const titleTcp = 'TCP';
    const titleIgr = 'IGR';
    const mp = useProjectMilestonesMappedData(data);
    if (!data || !mp) return null;

    const cards = [
        {
            total: mp.LegislativeApproval.projectCountTotal,
            info: t('extended_report.pending_legal_validity_extended'),
            lonValue: mp.LegislativeApproval.projectCountTotalLon,
            tcpValue: mp.LegislativeApproval.projectCountTotalTcp,
            igrValue: mp.LegislativeApproval.projectCounTotalIgr,
        },
        {
            total: mp.NotFullyDisbursed.totalProjectCount,
            info: t('extended_report.extension_of_disbursements'),
            lonValue: mp.NotFullyDisbursed.totalLonProjectCount,
            tcpValue: mp.NotFullyDisbursed.totalTcpProjectCount,
            igrValue: mp.NotFullyDisbursed.totalIgrProjectCount,
        },
        {
            total: mp.DisbursementEligibility.totalProjectCount,
            info: t('extended_report.pending_eligibility'),
            lonValue: mp.DisbursementEligibility.totalLonProjectCount,
            tcpValue: mp.DisbursementEligibility.totalTcpProjectCount,
            igrValue: mp.DisbursementEligibility.totalIgrProjectCount,
        },
        {
            total: mp.AboutToExpire.totalProjectCount,
            info: t('extended_report.projects_to_expiring'),
            lonValue: mp.AboutToExpire.totalLonProjectCount,
            tcpValue: mp.AboutToExpire.totalTcpProjectCount,
            igrValue: mp.AboutToExpire.totalIgrProjectCount,
        },
        {
            total: mp.expiredProjects.totalProjectCount,
            info: t('extended_report.ext_defeated'),
            lonValue: mp.expiredProjects.totalLonProjectCount,
            tcpValue: mp.expiredProjects.totalTcpProjectCount,
            igrValue: mp.expiredProjects.totalIgrProjectCount,
        },
    ];

    return (
        <>
            <div className='content-milestones c-main'>
                <HeaderExtended
                    portfolioName={portfolioName}
                    filtersApplied={filtersApplied ?? labels}
                    creationDate={creationDate}
                    regions={regions}
                    countries={countries}
                    myPortfolio={myPortfolio}
                />
                <section className="milestones">
                    <header className="header-content mb-2">
                        <p>{t('extended_report.project_lifecycle_milestones')}</p>
                        <div className='flex-avatars'>
                            {(isLoan) && (<ReusableIcon title={titleLon} color="#BE86D8" />)}
                            {(isTcp) && (<ReusableIcon title={titleTcp} color="#66B6B6" />)}
                            {(isIgr) && (<ReusableIcon title={titleIgr} color="#F1AF43" />)}
                        </div>
                    </header>

                    <div className="milestones-grid">
                        {cards.map((c, idx) => (
                            <MilestoneCard
                                key={idx}
                                total={c.total}
                                info={c.info}
                                isLoan={isLoan}
                                isTcp={isTcp}
                                isIgr={isIgr}
                                lonValue={c.lonValue}
                                tcpValue={c.tcpValue}
                                igrValue={c.igrValue}
                            />
                        ))}
                    </div>
                </section>
            </div>
        </>
    )
}

export default ProjectMilestones